export default __webpack_public_path__ + "static/media/displayShine.6e305525.png";